var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSortLabel = void 0;
var TableSortLabel_1 = __importDefault(require("./TableSortLabel"));
exports.TableSortLabel = TableSortLabel_1.default;
exports.default = TableSortLabel_1.default;
//# sourceMappingURL=index.js.map